var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "top" }, [
    _c("div", { staticClass: "examUser" }, [
      _c("img", {
        attrs: {
          src: require("../../../../../../static/images/testImgs/userImg.png")
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "right_msg" }, [
        _c("p", [_c("span", [_vm._v("姓名：")]), _vm._v(_vm._s(_vm.name))]),
        _vm._v(" "),
        _c("p", [
          _c("span", [_vm._v("性别：")]),
          _vm._v(_vm._s(_vm.sex == "1" ? "男" : "女"))
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1)
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "exam_subject" }, [
      _c("span", [_vm._v(_vm._s(this.$route.query.paperName))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "exam_time" }, [
      _c("b", { staticClass: "downTime" }, [
        _vm._v("科目剩余时间：" + _vm._s(_vm.countDown) + " ")
      ]),
      _vm._v(" "),
      !this.showBack
        ? _c("span", { on: { click: _vm.submitTest } }, [_vm._v("交卷")])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", [_vm._v("准考证号：")]),
      _vm._v("11111111111111")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", [_vm._v("证件号码：")]),
      _vm._v("11111111111111")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-594b09ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-594b09ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/testSumulationComponentNew/header.vue
// module id = null
// module chunks = 